import * as Yup from 'yup'

export const addressFormValues = (customer = {}) => {
    return {
        address_type: "Shipping",
        shipping_first_name: customer.first_name || "",
        shipping_middle_name: customer.middle_name || "",
        shipping_last_name: customer.last_name,
        shipping_company_name: customer.company_name || "",
        shipping_address: "",
        shipping_address1: "",
        shipping_city: "",
        shipping_country: "",
        shipping_state: "",
        shipping_zipcode: "",
        shipping_phone: "",
        shipping_mobile: "",
        shipping_fax: "",
    }
}

export const addressFormVS = Yup.object({
    // address_type: Yup.string().required("This field is required"),
    shipping_first_name: Yup.string().required("This field is required"),
    shipping_company_name: Yup.string().required("This field is required"),
    shipping_last_name: Yup.string().required("This field is required"),
    shipping_address: Yup.string().required("This field is required"),
    shipping_city: Yup.string().required("This field is required"),
    shipping_country: Yup.string().required("This field is required"),
    shipping_state: Yup.string().required("This field is required"),
    shipping_mobile: Yup.string()
        .required("This field is required")
        .min(8, 'Invalid number')
        .max(12, 'Invalid number')
})